import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
interface User {
  name: string;
  email: string;
  phone: string;
}
@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
  userscol: AngularFirestoreCollection<User>;
  users: Observable<User[]>;
  constructor(private afs: AngularFirestore) { }

  ngOnInit() {
    this.userscol = this.afs.collection('users');
    this.users = this.userscol.valueChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/users/users-list/users-list.component.ts